export default __webpack_public_path__ + "static/media/client17.728a4d93.png";